(() => {
  function pad2(n) {
    return n.toString().padStart(2, '0');
  }

  function select(root, selector) {
    return root.querySelector(selector);
  }

  function setInsetVars(bar, position) {
    const root = document.documentElement;
    const height = Math.ceil(bar.getBoundingClientRect().height || 0);
    root.style.setProperty('--zc-countdown-dynamic-height', `${height}px`);
    root.removeAttribute('data-zc-countdown-top');
    root.removeAttribute('data-zc-countdown-bottom');
    if (position === 'bottom') {
      root.setAttribute('data-zc-countdown-bottom', 'true');
    } else {
      root.setAttribute('data-zc-countdown-top', 'true');
    }
  }

  function startCountdown(bar) {
    const endIso = bar.getAttribute('data-end-iso');
    if (!endIso) return;
    const end = new Date(endIso);
    if (isNaN(end.getTime())) return;

    const daysEl = select(bar, '.zc-countdown__value[data-unit="days"]');
    const hoursEl = select(bar, '.zc-countdown__value[data-unit="hours"]');
    const minutesEl = select(bar, '.zc-countdown__value[data-unit="minutes"]');
    const secondsEl = select(bar, '.zc-countdown__value[data-unit="seconds"]');

    function update() {
      const now = new Date();
      let secondsRemaining = Math.floor((end.getTime() - now.getTime()) / 1000);

      if (secondsRemaining <= 0) {
        clearInterval(timer);
        if (daysEl) daysEl.textContent = '0';
        if (hoursEl) hoursEl.textContent = '00';
        if (minutesEl) minutesEl.textContent = '00';
        if (secondsEl) secondsEl.textContent = '00';
        cleanup();
        return;
      }

      const days = Math.floor(secondsRemaining / 86400);
      secondsRemaining -= days * 86400;
      const hours = Math.floor(secondsRemaining / 3600);
      secondsRemaining -= hours * 3600;
      const minutes = Math.floor(secondsRemaining / 60);
      const seconds = secondsRemaining - minutes * 60;

      if (daysEl) daysEl.textContent = String(days);
      if (hoursEl) hoursEl.textContent = pad2(hours);
      if (minutesEl) minutesEl.textContent = pad2(minutes);
      if (secondsEl) secondsEl.textContent = pad2(seconds);
    }

    function cleanup() {
      const root = document.documentElement;
      bar.classList.add('zc-countdown-bar--hidden');
      root.removeAttribute('data-zc-countdown-bottom');
      root.removeAttribute('data-zc-countdown-top');
      root.style.removeProperty('--zc-countdown-dynamic-height');
    }

    const timer = setInterval(update, 1000);
    update();
  }

  function init() {
    const bar = document.querySelector('.zc-countdown-bar');
    if (!bar) return;

    document.documentElement.setAttribute('data-zc-countdown-active', 'true');

    const position = bar.getAttribute('data-position') === 'bottom' ? 'bottom' : 'top';
    setInsetVars(bar, position);

    if ('ResizeObserver' in window) {
      const ro = new ResizeObserver(() => setInsetVars(bar, position));
      ro.observe(bar);
    } else {
      const handler = typeof debounce === 'function'
        ? debounce(() => setInsetVars(bar, position), 150)
        : () => setInsetVars(bar, position);
      window.addEventListener('resize', handler);
      window.addEventListener('orientationchange', handler);
    }

    startCountdown(bar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();


